import axios from 'axios';

const createUser = async (user) => {
  return await axios.post(window.url_api+'/users', user);
};

const updateUserMe = async (user) => {
  return await axios.put(window.url_api+'/users/me', user);
};

const getUsers = async (id) => {
  return await axios.get(window.url_api+'/users');
};

const updateUsers = async (user) => {
  return await axios.put(window.url_api+'/users/'+user.id, user);
};

const deleteUsers = async (id) => {
  return await axios.delete(window.url_api+'/users/'+id);
};


export default {
  createUser,
  updateUserMe,
  getUsers,
  updateUsers,
  deleteUsers
};
